const actions = {
    CONFIGURATION_BEGIN: 'CONFIGURATION_BEGIN',
    CONFIGURATION_SUCCESS: 'CONFIGURATION_SUCCESS',
    CONFIGURATION_ERR: 'CONFIGURATION_ERR',

    configurationBegin: () => {
        return {
            type: actions.CONFIGURATION_BEGIN,
        };
    },
    configurationSuccess: (data) => {
        return {
            type: actions.CONFIGURATION_SUCCESS,
            data,
        };
    },

    configurationErr: (err) => {
        return {
            type: actions.CONFIGURATION_ERR,
            err,
        };
    },
};
export default actions;
